import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@shared-components/shadcn/chart";
import { api } from "@shared-server/api";
import {
  Bar,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import { COLORS, formatGranularDateTick } from "./metric-utils";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
import { useDepartmentStackContext } from "@shared-components/department-stack-provider";

const chartConfig: ChartConfig = {
  count: {
    label: "Chats",
  },
};

type ChatsProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};

export const ChatsWithDepartments = (props: ChatsProps) => {
  const { parentDepartmentId } = useDepartmentStackContext();
  // Query
  const coreMetricsQuery = api.coreMetrics.chatsAttemptedByDepartment.useQuery({
    startDate: props.startDate,
    endDate: props.endDate,
    granularity: props.granularity,
    parentDepartmentId: parentDepartmentId,
  });

  const chartData = coreMetricsQuery.data?.chartDepartmentData ?? [];
  const departments = coreMetricsQuery.data?.departments ?? [];

  return (
    <div>
      <h2 className="mb-4">{"Chats"}</h2>
      <ChartContainer
        config={chartConfig}
        className="aspect-auto h-[150px] w-full"
      >
        <ComposedChart accessibilityLayer data={chartData}>
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey="date"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            minTickGap={32}
            tickFormatter={(value: string) =>
              formatGranularDateTick(value, props.granularity)
            }
          />
          <YAxis yAxisId="count" interval={1} orientation="left" />
          <ChartTooltip
            content={
              <ChartTooltipContent
                nameKey="date"
                wrapperStyle={{ zIndex: 1 }}
                itemsContainerClassName="grid grid-cols-3 gap-2"
                labelFormatter={(value: string) => {
                  return value;
                }}
              />
            }
          />

          <Legend />

          {departments.map((department, departmentIndex) => (
            <Bar
              key={department.id}
              yAxisId="count"
              dataKey={department.id}
              name={department.name}
              fill={COLORS[departmentIndex % COLORS.length]}
            />
          ))}
        </ComposedChart>
      </ChartContainer>
    </div>
  );
};
